module.exports = __webpack_public_path__ + "img/video15.95ece268.jpg";